module.exports = __webpack_public_path__ + "img/new-01.5428f8bb.jpg";